import Routes from "@/common/router/Routes";
import WorkPeriodRouter from "@/context/work_period/router/WorkPeriodTemplateRouter";

export default class WorkPeriodTemplateRoutes extends Routes {
  private static _instance: WorkPeriodTemplateRoutes;
  public static instance(): WorkPeriodTemplateRoutes {
    if (!WorkPeriodTemplateRoutes._instance) {
      WorkPeriodTemplateRoutes._instance = new WorkPeriodTemplateRoutes();
    }
    return WorkPeriodTemplateRoutes._instance;
  }
  private constructor() {
    super({
      label: "Czas pracy",
      router: WorkPeriodRouter.instance(),
      lazyPage: () => import("@/context/work_period/page/WorkPeriodTemplatePage.vue"),
      lazyCreate: () => import("@/context/work_period/containers/WorkPeriodFormContainer.vue"),
      lazyList: () =>
        import("@/context/work_period/containers/WorkPeriodTemplateListContainer.vue"),
      lazyUpdate: () => import("@/context/work_period/containers/WorkPeriodFormContainer.vue")
    });

    this.addChild({
      path: "assign",
      name: "assign",
      label: "Masowe przypisanie obiektów",
      visible: true,
      component: () => import("@/context/work_period/containers/AssignWorkPeriodContainer.vue"),
      url: `${this.router.basePath}/assign`
    });
  }
}
